
import { DisablableOption, ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";
import { AbilityScoreType } from "@dndModels/Types";

export interface Skill extends ModelBase {
  data_type: "skill";
  _id: string;
  name: string;
  description: string;
  use_ability_score: AbilityScoreType | "None"; // = "None";

  // constructor(obj?: any) {
  //   super(obj);
  //   if (obj) {
  //     this.use_ability_score = obj.use_ability_score && obj.use_ability_score !== "" ? obj.use_ability_score : "None";
  //   }
  // }

  // toDBObj(): any {
  //   const base_db_obj = super.toDBObj();
  //   return {
  //     ...base_db_obj,
  //     use_ability_score: this.use_ability_score
  //   };
  // }

  // copy(copyMe: Skill, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  //   this.use_ability_score = copyMe.use_ability_score;
  // }

  // clone(drop_ids: boolean = false): Skill {
  //   const new_obj = new Skill();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }

  // copy5e(copyMe: any): void {
  //   this.name = copyMe.name;
  //   this.description = "";
  //   if (copyMe.desc) {
  //     copyMe.desc.forEach((d: string) => {
  //       this.description += d + "\n ";
  //     });
  //   }
  //   if (copyMe.ability_score) {
  //     this.use_ability_score = copyMe.ability_score.name;
  //   } else {
  //     this.use_ability_score = "None";
  //   }
  // }
}

export const SKILLS: Skill[] =
  [{
    data_type: "skill",
    _id: "5fc57494f3e883057c6bbb2f",
    name: "Stealth",
    description: "Make a Dexterity (Stealth) check when you attempt to conceal yourself from enemies, slink past guards, slip away without being noticed, or sneak up on someone without being seen or heard.",
    use_ability_score: "DEX",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    variant_group: [],
    variant_ids: [],
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    // non_version_variant: false,
    // use_base_name: false,
    source_book_abbrev: "",
    monster: false,
    template_only: false,
    image_url: "",
    reusable_string_ids: [],
    archived: false, linkifiedName: "", linkURL: "",
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_group_id: "",
    // // variant_of_name: "",
    is_dominant: true,
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_ids: [],
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Stealth",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fe2ba391a2444180ced3b4f",
    name: "Deception",
    description: "Your Charisma (Deception) check determines whether you can convincingly hide the truth, either verbally or through your actions. This deception can encompass everything from misleading others through ambiguity to telling outright lies. Typical situations include trying to fast- talk a guard, con a merchant, earn money through gambling, pass yourself off in a disguise, dull someone's suspicions with false assurances, or maintain a straight face while telling a blatant lie.",
    use_ability_score: "CHA",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Deception",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fe2ba861a2444180ced3b50",
    name: "Sleight of Hand",
    description: "Whenever you attempt an act of legerdemain or manual trickery, such as planting something on someone else or concealing an object on your person, make a Dexterity (Sleight of Hand) check. The GM might also call for a Dexterity (Sleight of Hand) check to determine whether you can lift a coin purse off another person or slip something out of another person's pocket.",
    use_ability_score: "DEX",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Sleight of Hand",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74287494ba20cca8a9e2",
    name: "Acrobatics",
    description: "Your Dexterity (Acrobatics) check covers your attempt to stay on your feet in a tricky situation, such as when you're trying to run across a sheet of ice, balance on a tightrope, or stay upright on a rocking ship's deck. The GM might also call for a Dexterity (Acrobatics) check to see if you can perform acrobatic stunts, including dives, rolls, somersaults, and flips.\n ",
    use_ability_score: "DEX",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Acrobatics",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74287494ba20cca8a9e3",
    name: "Animal Handling",
    description: "When there is any question whether you can calm down a domesticated animal, keep a mount from getting spooked, or intuit an animal's intentions, the GM might call for a Wisdom (Animal Handling) check. You also make a Wisdom (Animal Handling) check to control your mount when you attempt a risky maneuver.\n ",
    use_ability_score: "WIS",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Animal Handling",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74297494ba20cca8a9e4",
    name: "Arcana",
    description: "Your Intelligence (Arcana) check measures your ability to recall lore about spells, magic items, eldritch symbols, magical traditions, the planes of existence, and the inhabitants of those planes.\n ",
    use_ability_score: "INT",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Arcana",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74297494ba20cca8a9e5",
    name: "Athletics",
    description: "Your Strength (Athletics) check covers difficult situations you encounter while climbing, jumping, or swimming.\n ",
    use_ability_score: "STR",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Athletics",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742a7494ba20cca8a9e6",
    name: "History",
    description: "Your Intelligence (History) check measures your ability to recall lore about historical events, legendary people, ancient kingdoms, past disputes, recent wars, and lost civilizations.\n ",
    use_ability_score: "INT",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "History",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742b7494ba20cca8a9e7",
    name: "Insight",
    description: "Your Wisdom (Insight) check decides whether you can determine the true intentions of a creature, such as when searching out a lie or predicting someone's next move. Doing so involves gleaning clues from body language, speech habits, and changes in mannerisms.\n ",
    use_ability_score: "WIS",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Insight",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742b7494ba20cca8a9e8",
    name: "Intimidation",
    description: "When you attempt to influence someone through overt threats, hostile actions, and physical violence, the GM might ask you to make a Charisma (Intimidation) check. Examples include trying to pry information out of a prisoner, convincing street thugs to back down from a confrontation, or using the edge of a broken bottle to convince a sneering vizier to reconsider a decision.\n ",
    use_ability_score: "CHA",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Intimidation",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742c7494ba20cca8a9e9",
    name: "Investigation",
    description: "When you look around for clues and make deductions based on those clues, you make an Intelligence (Investigation) check. You might deduce the location of a hidden object, discern from the appearance of a wound what kind of weapon dealt it, or determine the weakest point in a tunnel that could cause it to collapse. Poring through ancient scrolls in search of a hidden fragment of knowledge might also call for an Intelligence (Investigation) check.\n ",
    use_ability_score: "INT",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Investigation",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742d7494ba20cca8a9ea",
    name: "Medicine",
    description: "A Wisdom (Medicine) check lets you try to stabilize a dying companion or diagnose an illness.\n ",
    use_ability_score: "WIS",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Medicine",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742d7494ba20cca8a9eb",
    name: "Nature",
    description: "Your Intelligence (Nature) check measures your ability to recall lore about terrain, plants and animals, the weather, and natural cycles.\n ",
    use_ability_score: "INT",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Nature",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742e7494ba20cca8a9ec",
    name: "Perception",
    description: "Your Wisdom (Perception) check lets you spot, hear, or otherwise detect the presence of something. It measures your general awareness of your surroundings and the keenness of your senses. For example, you might try to hear a conversation through a closed door, eavesdrop under an open window, or hear monsters moving stealthily in the forest. Or you might try to spot things that are obscured or easy to miss, whether they are orcs lying in ambush on a road, thugs hiding in the shadows of an alley, or candlelight under a closed secret door.\n ",
    use_ability_score: "WIS",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Perception",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef742e7494ba20cca8a9ed",
    name: "Performance",
    description: "Your Charisma (Performance) check determines how well you can delight an audience with music, dance, acting, storytelling, or some other form of entertainment.\n ",
    use_ability_score: "CHA",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Performance",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74307494ba20cca8a9ee",
    name: "Persuasion",
    description: "When you attempt to influence someone or a group of people with tact, social graces, or good nature, the GM might ask you to make a Charisma (Persuasion) check. Typically, you use persuasion when acting in good faith, to foster friendships, make cordial requests, or exhibit proper etiquette. Examples of persuading others include convincing a chamberlain to let your party see the king, negotiating peace between warring tribes, or inspiring a crowd of townsfolk.\n ",
    use_ability_score: "CHA",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Persuasion",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    _id: "5fef74307494ba20cca8a9ef",
    name: "Religion",
    description: "Your Intelligence (Religion) check measures your ability to recall lore about deities, rites and prayers, religious hierarchies, holy symbols, and the practices of secret cults.\n ",
    use_ability_score: "INT",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Religion",
    tag_string: "", free: false
  }, {
    data_type: "skill",
    tag_string: "", free: false,
    _id: "5fef74317494ba20cca8a9f0",
    name: "Survival",
    description: "The GM might ask you to make a Wisdom (Survival) check to follow tracks, hunt wild game, guide your group through frozen wastelands, identify signs that owlbears live nearby, predict the weather, or avoid quicksand and other natural hazards.\n ",
    use_ability_score: "WIS",
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, true_variant: false, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Survival"
  }
]

export const SKILL_OPTIONS = SKILLS.map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});